// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CheckCircleComponent} from './CheckCircle.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCheckCircle = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CheckCircleComponent/>
  </Icon>
));
